// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/cjs.js!../../../../shared/brand-variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/cjs.js!../../../../shared/responsive-variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Brand Variables */

.sidebar {
  width: 220px;
  /* Exactly one viewport tall — do NOT let the sidebar stretch to
     match a tall main pane. Was \`min-height: 100vh\`, which made the
     sidebar grow with its flex-row sibling (\`.layout-main\`) whenever
     the docs page's content pushed \`.layout\` past viewport height;
     the sidebar's footer then rode below the fold as the user
     scrolled the page. Combined with \`align-self\` + \`position:
     sticky\` (tablet+ media query below), the sidebar is now
     viewport-sized and pinned regardless of what main demands. */
  height: 100vh;
  /* Belt to the height rule: even inside a stretch-aligned flex row,
     the sidebar sits at the top rather than absorbing extra vertical
     space from a taller sibling. */
  align-self: flex-start;
  background: var(--color-primary);
  color: var(--color-surface);
  display: flex;
  flex-direction: column;
  padding: 0;
  flex-shrink: 0;
  box-shadow: var(--shadow-lg);
  transition: transform 0.3s ease-out;
}

.sidebar-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 16px;
  border-bottom: 1px solid var(--color-primary-light);
  position: relative;
}

.sidebar-logo {
  width: 32px;
  height: 32px;
  background: var(--color-secondary);
  border-radius: var(--border-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  color: var(--color-surface);
  box-shadow: var(--shadow-sm);
}

.sidebar-title {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--color-surface);
}

.sidebar-close {
  display: none;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: var(--color-surface);
  font-size: 24px;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.sidebar-close:hover {
  opacity: 1;
}

.sidebar-nav {
  flex: 1;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 6px;
  color: #94a3b8;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.15s, color 0.15s;
  min-height: var(--touch-target-min);
}

.sidebar-link:hover {
  background: #1e293b;
  color: #e2e8f0;
}

.sidebar-link--active {
  background: #1e293b;
  color: #fff;
}

.sidebar-link-icon {
  font-size: 18px;
  width: 24px;
  text-align: center;
  flex-shrink: 0;
}

.sidebar-link-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-footer {
  padding: 8px;
  border-top: 1px solid #1e293b;
}

.sidebar-legal {
  padding: 8px 12px 4px;
  font-size: 12px;
  color: #64748b;
}

.sidebar-legal a {
  color: inherit;
  text-decoration: none;
}

.sidebar-legal a:hover {
  color: #e2e8f0;
  text-decoration: underline;
}

/* Mobile: Slide-in sidebar */
@media (max-width: 767px) {
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: var(--z-mobile-nav);
    transform: translateX(-100%);
  }

  .sidebar--mobile-open {
    transform: translateX(0);
  }

  .sidebar-close {
    display: block;
  }
}

/* Tablet and up: Always visible */
@media (min-width: 768px) {
  .sidebar {
    /* Sticky (not relative) so the sidebar stays pinned to the
       viewport as the page scrolls. Without this, when the docs
       page grows past 100vh the page itself scrolls (rather than
       an inner container) and the sidebar scrolls up with it,
       taking its footer link out of view. \`top: 0\` anchors the
       sidebar to the top of its containing scroll context. */
    position: sticky;
    top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAI3B;EACE,YAAY;EACZ;;;;;;;iEAO+D;EAC/D,aAAa;EACb;;mCAEiC;EACjC,sBAAsB;EACtB,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,cAAc;EACd,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE;;;;;6DAKyD;IACzD,gBAAgB;IAChB,MAAM;EACR;AACF","sourcesContent":["/* Import Brand Variables */\n@import '../../../../shared/brand-variables.css';\n@import '../../../../shared/responsive-variables.css';\n\n.sidebar {\n  width: 220px;\n  /* Exactly one viewport tall — do NOT let the sidebar stretch to\n     match a tall main pane. Was `min-height: 100vh`, which made the\n     sidebar grow with its flex-row sibling (`.layout-main`) whenever\n     the docs page's content pushed `.layout` past viewport height;\n     the sidebar's footer then rode below the fold as the user\n     scrolled the page. Combined with `align-self` + `position:\n     sticky` (tablet+ media query below), the sidebar is now\n     viewport-sized and pinned regardless of what main demands. */\n  height: 100vh;\n  /* Belt to the height rule: even inside a stretch-aligned flex row,\n     the sidebar sits at the top rather than absorbing extra vertical\n     space from a taller sibling. */\n  align-self: flex-start;\n  background: var(--color-primary);\n  color: var(--color-surface);\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  flex-shrink: 0;\n  box-shadow: var(--shadow-lg);\n  transition: transform 0.3s ease-out;\n}\n\n.sidebar-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 20px 16px;\n  border-bottom: 1px solid var(--color-primary-light);\n  position: relative;\n}\n\n.sidebar-logo {\n  width: 32px;\n  height: 32px;\n  background: var(--color-secondary);\n  border-radius: var(--border-radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 16px;\n  color: var(--color-surface);\n  box-shadow: var(--shadow-sm);\n}\n\n.sidebar-title {\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: var(--color-surface);\n}\n\n.sidebar-close {\n  display: none;\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: var(--color-surface);\n  font-size: 24px;\n  cursor: pointer;\n  padding: 4px;\n  line-height: 1;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.sidebar-close:hover {\n  opacity: 1;\n}\n\n.sidebar-nav {\n  flex: 1;\n  padding: 12px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  overflow-y: auto;\n}\n\n.sidebar-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 6px;\n  color: #94a3b8;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.15s, color 0.15s;\n  min-height: var(--touch-target-min);\n}\n\n.sidebar-link:hover {\n  background: #1e293b;\n  color: #e2e8f0;\n}\n\n.sidebar-link--active {\n  background: #1e293b;\n  color: #fff;\n}\n\n.sidebar-link-icon {\n  font-size: 18px;\n  width: 24px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.sidebar-link-label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar-footer {\n  padding: 8px;\n  border-top: 1px solid #1e293b;\n}\n\n.sidebar-legal {\n  padding: 8px 12px 4px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.sidebar-legal a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.sidebar-legal a:hover {\n  color: #e2e8f0;\n  text-decoration: underline;\n}\n\n/* Mobile: Slide-in sidebar */\n@media (max-width: 767px) {\n  .sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    z-index: var(--z-mobile-nav);\n    transform: translateX(-100%);\n  }\n\n  .sidebar--mobile-open {\n    transform: translateX(0);\n  }\n\n  .sidebar-close {\n    display: block;\n  }\n}\n\n/* Tablet and up: Always visible */\n@media (min-width: 768px) {\n  .sidebar {\n    /* Sticky (not relative) so the sidebar stays pinned to the\n       viewport as the page scrolls. Without this, when the docs\n       page grows past 100vh the page itself scrolls (rather than\n       an inner container) and the sidebar scrolls up with it,\n       taking its footer link out of view. `top: 0` anchors the\n       sidebar to the top of its containing scroll context. */\n    position: sticky;\n    top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
